import { IntlFormatters, MessageDescriptor } from 'react-intl';

import { LogEventResponse } from '@/components/app/layout/AnalyticsContextProvider';
import { Tile } from '@/components/ui/QuestionnaireTile/types';
import { LogEventArgs } from '@/hooks/analytics/types';

import { PersonalizedPlan } from '../../PreSignupProvider/types';

export function getChoicesFromTiles(
	tiles: Tile[] | undefined,
	formatMessage: IntlFormatters['formatMessage'],
): {
	id: string;
	text: string;
}[] {
	return (
		tiles?.map(tile => ({
			id: tile.id,
			text: formatMessage(tile.title as MessageDescriptor),
			redirectTo: tile.redirectTo,
		})) ?? []
	);
}

export async function onSelectChoice(
	choiceId: string,
	questionType: string | undefined,
	logEvent: ({ eventName, eventProps }: LogEventArgs) => Promise<LogEventResponse>,
): Promise<void> {
	await logEvent({
		eventName: 'FTUE : Intro Questions : Choice Selected',
		eventProps: {
			choice: choiceId,
			question_type: questionType as string,
		},
	});
}

export function getInitiallySelectedChoiceIds(
	tiles: Tile[] | undefined,
	personalizedPlan: PersonalizedPlan,
	activeScreen: string,
): string[] | undefined {
	return tiles?.map(tile => tile.id)?.filter(tileId => tileId in (personalizedPlan?.[activeScreen] || {}));
}
